
export interface IconProp {
    fill?: string
    strokeWidth?: string
    width?: string
    height?: string
}

const IconArrow = (props: IconProp) => {
    return (
        <svg
            width={props?.width || "8"}
            height={props?.height || "14"}
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M7 13L1 7L7 1"
                stroke={props?.fill || "#050505"}
                strokeWidth={props?.strokeWidth || "2"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>

    )
}

export default IconArrow